import { useSearch } from "@tanstack/react-router";
import { useView } from "../contexts/ViewContext";
import { isTodayOnlyDateFilter } from "../lib/todayBoardFocus";
import { useFilters } from "./queries/useFilters";
import { useTaskEditing, type UseTaskEditingArgs } from "./useTaskEditing";

/**
 * useTaskEditing for the app shell. A saved Today filter makes the dialog
 * arrows step through the tasks and sub-tasks dated today, not every card
 * the board is showing for context.
 */
export function useTodoTaskEditing(args: UseTaskEditingArgs) {
  const { viewType, searchTerm, activeFilterId, showCompleted } = useView();
  const { data: filters = [] } = useFilters();
  const { subtask } = useSearch({ strict: false }) as { subtask?: string };
  const dateFilters = filters.find((filter) => filter.id === activeFilterId)
    ?.date_filters;
  return useTaskEditing({
    ...args,
    activeSubtaskId: subtask ?? null,
    navigationFocus: {
      active:
        viewType === "board" &&
        !!activeFilterId &&
        !searchTerm.trim() &&
        isTodayOnlyDateFilter(dateFilters),
      showCompleted,
    },
  });
}
